import styled, { css } from 'styled-components';

import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

export const SsoButtonsWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 8px;
  align-self: stretch;

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      align-self: center;
    `,
  )}
`;
